import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgConfettiDuotone = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="m6.441 16.941 4.618 4.618L5.52 23.57a.852.852 0 0 1-1.094-1.093L6.44 16.94Zm15.184-.516-10.05-10.05a.852.852 0 0 0-1.403.312l-1.63 4.485 8.293 8.292 4.484-1.63a.852.852 0 0 0 .306-1.41Z"
      opacity={0.2}
    />
    <path d="M12.194 5.756a1.728 1.728 0 0 0-2.844.631L3.61 22.18a1.731 1.731 0 0 0 1.613 2.32 1.75 1.75 0 0 0 .597-.11l15.79-5.742a1.727 1.727 0 0 0 .633-2.843L12.194 5.756Zm-.91 14.789-3.829-3.828 1.44-3.96 6.349 6.349-3.96 1.439Zm-6.016 2.188 1.53-4.202 2.675 2.675-4.205 1.527Zm11.794-4.288-7.507-7.508 1.422-3.923 10 10-3.915 1.431Zm.438-10.57c.017-.592.16-1.173.42-1.704.58-1.158 1.673-1.796 3.08-1.796.733 0 1.203-.25 1.493-.789.153-.3.24-.63.257-.968a.875.875 0 0 1 1.75.007c0 1.407-.932 3.5-3.5 3.5-.733 0-1.203.25-1.493.789-.153.3-.24.63-.257.968a.876.876 0 1 1-1.75-.007Zm-2.625-3.5V1.75a.875.875 0 0 1 1.75 0v2.625a.875.875 0 0 1-1.75 0Zm11.12 9.006a.877.877 0 0 1-.62 1.494.876.876 0 0 1-.619-.257l-1.75-1.75a.876.876 0 1 1 1.238-1.238l1.75 1.75Zm.532-4.676-2.625.875a.875.875 0 1 1-.554-1.66l2.625-.875a.875.875 0 0 1 .554 1.66Z" />
  </svg>
);
export default SvgConfettiDuotone;
